import React from 'react';
import { Modal } from 'react-bootstrap';
import './scss/FullpageModal.scss';

const FullpageModal = ({ show, handleClose, modalBody }) => {
    return (
        <Modal show={show} onHide={handleClose}
            id="FullpageMainModal" className=" ">
            <Modal.Body>
                <Modal.Header className="px-0">
                    <span className='common big' />
                    <button onClick={() => handleClose(true)}>
                        Close
                    </button>
                </Modal.Header>
                {modalBody}
            </Modal.Body>
        </Modal>
    );
};

export default FullpageModal;